
export default {
    name: 'DescriptionTabComponent',
    components: {
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        validForm: {
            type: Boolean,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model para el formulario
        isValidForm: false,
    }),
    computed: {
    },
    created () {
    },
    beforeDestroy() {
    },
    mounted () {
    },
    methods: {
    },
    watch: {
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.descriptionDataTabForm) {
                this.$refs.descriptionDataTabForm.resetValidation()
            }
        },
        isValidForm(newVal, oldVal){
            if(newVal !== oldVal){
                this.$emit('update:validForm', newVal)
            }
        },
    }
}
